export enum ReducerNames {
  SEARCH = 'search',
  SEARCH_EXPORT = 'searchExport',
  SEARCH_DETAILS = 'searchDetails',
  LOGIN = 'login',
  FORM = 'form',
  SEARCH_HISTORY = 'searchHistory',
  PROPERTY_SEARCH = 'propertySearch',
  PROPERTY_SEARCH_DETAILS = 'propertySearchDetails',
  RECENT_REPORTS = 'recentReports',
  TAX_MAPS = 'taxMaps',
  DEP_ONLINE = 'depOnline',
  XOSIMAGE = 'xosImage',
  DOCIMAGES = 'docimages',
  DEP_ONLINE_DETAILS = 'depOnlineDetails',
  BANKRUPTCY = 'bankruptcy',
  BANKRUPTCY_DETAILS = 'bankruptcyDetails',
  PREACRIS = 'preacris',
  LICENSE = 'license',
  USER_USAGE_REPORT = 'userUsageReport',
  TAXTRAX = 'taxTrax',
  TAXTRAX_TAX_BILLS = 'taxTraxTaxBills',
  TAXTRAX_TAX_BILL_RECORD = 'taxTraxTaxBillRecord',
  MAINTENANCE_MESSAGE = 'maintenanceMessage',
}
